import React, { useEffect, useState } from 'react';
import { fetchDesignationsList, deleteDesignation } from './services/api';
import { Designation } from './types';
import { useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Table, Button, Alert, Spinner, Card } from 'react-bootstrap';

const DesignationList: React.FC = () => {
  const [designations, setDesignations] = useState<Designation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const [deletingId, setDeletingId] = useState<number | null>(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchDesignationsList();
        const designations = Array.isArray(response.data) ? response.data : [];
        setDesignations(designations);
      } catch (error) {
        console.error('Error loading designations:', error);
        setError('Failed to load designations');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm('Are you sure you want to delete this designation?')) return;
    setDeletingId(id);
    try {
      await deleteDesignation(id);
      setDesignations(designations => designations.filter(d => d.id !== id));
    } catch (error) {
      console.error('Error deleting designation:', error);
      alert('Failed to delete designation');
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="p-4 p-md-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="mb-0">Designations</h2>
        <Button variant="primary" onClick={() => navigate('/designations/create')}>
          <i className="fas fa-plus me-2"></i> Create Designation
        </Button>
      </div>
      {error && <Alert variant="danger">{error}</Alert>}
      <Card className="shadow-sm">
        <div className="table-responsive">
          <Table bordered hover className="mb-0">
            <thead className="table-light">
              <tr>
                <th>Name</th>
                <th>User Type</th>
                <th>Remote Check-in</th>
                <th style={{ width: 120 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 5 }).map((_, i) => (
                  <tr key={i}>
                    <td><Skeleton /></td>
                    <td><Skeleton /></td>
                    <td><Skeleton width={60} /></td>
                    <td><Skeleton width={70} /></td>
                  </tr>
                ))
              ) : designations.length === 0 ? (
                <tr><td colSpan={4} className="text-center">No designations found.</td></tr>
              ) : (
                designations.map(d => (
                  <tr key={d.id}>
                    <td>{d.name}</td>
                    <td>{d.user_type}</td>
                    <td>{d.remote_checkin ? 'Yes' : 'No'}</td>
                    <td>
                      <button className="btn btn-sm btn-outline-primary me-2" onClick={() => navigate(`/designations/edit/${d.id}`)}>
                        <i className="fas fa-edit"></i>
                      </button>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(d.id)} disabled={deletingId === d.id}>
                        {deletingId === d.id ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-trash"></i>}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Card>
    </div>
  );
};

export default DesignationList; 